export default __webpack_public_path__ + "static/media/Predict_Cashflow_Illustration.e811681b.svg";